var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.hardRefresh
      ? _c(
          "div",
          { class: { "main-content": !_vm.inModal } },
          [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-header" }, [
                _c("h5", [
                  _vm._v(
                    _vm._s(_vm.refund ? "Возврат заявки" : "Обработка заявки") +
                      " "
                  ),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$route.params.id || _vm.orderId)),
                  ]),
                  _vm._v(" "),
                  _vm.$editNewOrder.type_id === 2
                    ? _c("span", { staticClass: "red" }, [
                        _vm._v(
                          "(возврат " +
                            _vm._s(_vm.$editNewOrder.related_order_id) +
                            ")"
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.refund
                    ? _c(
                        "span",
                        {
                          class: {
                            badge: true,
                            "badge-dark": [0, 9999].includes(
                              +_vm.$editNewOrder.status
                            ),
                            "badge-info": [1, 2, 8].includes(
                              +_vm.$editNewOrder.status
                            ),
                            "badge-success": [3, 11].includes(
                              +_vm.$editNewOrder.status
                            ),
                            "badge-warning": [-2, -3].includes(
                              +_vm.$editNewOrder.status
                            ),
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$editNewOrder.status_label)
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$editNewOrder.site_mirror_id
                    ? _c("span", { staticClass: "badge badge-danger" }, [
                        _vm._v(_vm._s(_vm.getMirrorName(_vm.$editNewOrder))),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$editNewOrder.status === 9
                    ? _c("span", { staticClass: "badge badge-info" }, [
                        _vm._v(
                          "заявка предварительная и не учавствует в просчетах"
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _vm.$editNewOrder.status === 0 &&
                _vm.isOrderUnderManagerProgress(_vm.$editNewOrder.id) &&
                +_vm.isOrderUnderManagerProgress(_vm.$editNewOrder.id, true) !==
                  _vm.$currentUID
                  ? _c(
                      "div",
                      { staticClass: "alert alert-danger" },
                      [
                        _c("OrderInProgressByManager", {
                          attrs: { "order-id": _vm.$editNewOrder.id },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-12" },
                    [
                      _vm.$editNewOrder.id
                        ? [
                            _c("SelectProjectCity", {
                              attrs: {
                                onUpdate: (data) => this.updateLocality(data),
                              },
                            }),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.$editNewOrder.status === 3 &&
                  _vm.mixinIsAllowToView("orderSaleData")
                    ? _c(
                        "div",
                        { staticClass: "col-md-4" },
                        [
                          _c("SaleData", {
                            attrs: { order: _vm.$editNewOrder },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c("SelectClient", {
                    ref: "clientData",
                    attrs: { selectedPhones: _vm.$editNewOrder.order_phones },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.$editNewOrder.extra_options?.extra_drugs_display &&
            _vm.$editNewOrder.extra_options.extra_drugs_display.length
              ? _c("div", { staticClass: "card" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-body" }, [
                    _c(
                      "table",
                      {
                        staticClass:
                          "table table-sm table-hover table_extra_drugs",
                      },
                      [
                        _vm._m(2),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(
                            _vm.$editNewOrder.extra_options.extra_drugs_display,
                            function (drug, i) {
                              return !drug.drug_id
                                ? _c("tr", [
                                    _c("td", [_vm._v(_vm._s(i + 1))]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(drug.title))]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(drug.qty))]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(drug.price))]),
                                  ])
                                : _vm._e()
                            }
                          ),
                          0
                        ),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-8" },
                    [
                      _vm._l(_vm.drugsInOrder, function (drug, index) {
                        return [
                          _c(
                            "div",
                            { key: drug.id, staticClass: "drugSelected" },
                            [
                              _c("DrugSelect", {
                                ref: "SelectedDrug",
                                refInFor: true,
                                attrs: {
                                  onSelect: (d, hardRefresh = null) =>
                                    _vm.updateDrugData(d, index, hardRefresh),
                                  combinedDrugs:
                                    _vm.$editNewOrder.details.filter(
                                      (d) => d.parent_drug_id === drug.id
                                    ),
                                  searchType: "1",
                                  updateDeliveryDate: () =>
                                    _vm.checkDeliveryDate(),
                                  selectedDrug: drug,
                                },
                              }),
                              _vm._v(" "),
                              _vm.sendDrugMessage
                                ? _c(
                                    "div",
                                    { staticClass: "send_drug_btn_block" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-outline-info btn-xs",
                                          on: {
                                            click: () =>
                                              _vm.sendDrugMessage(
                                                _vm.$editNewOrder.drugs[index]
                                              ),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "Отправить\n                    препарат в чат\n                  "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "drugSelected" },
                        [
                          _c("DrugSelect", {
                            ref: "newDrug",
                            attrs: {
                              searchType: "1",
                              onSelect: (d) =>
                                _vm.updateDrugData(
                                  d,
                                  _vm.drugsInOrder.length,
                                  true
                                ),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-4" },
                    [
                      _c("OrderPriceDetails", {
                        ref: "OrderPriceDetails",
                        attrs: {
                          saveOrder: () => _vm.updateOrder(),
                          allowToUseCard: _vm.allowToUseCardForPrePaid,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c(
                  "div",
                  { staticClass: "flex flex_gap_10" },
                  [
                    _c("ReserveOrder", { ref: "ReserveOrder" }),
                    _vm._v(" "),
                    (_vm.$editNewOrder.files ?? []).length
                      ? _c("AttachedFiles", {
                          ref: "AttachedFiles",
                          attrs: { files: _vm.$editNewOrder.files },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _vm._m(4),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _vm.deliveryDateWarning
                    ? _c(
                        "div",
                        [
                          _c("RecommendedDeliveryDate", {
                            attrs: {
                              deliveryDate: _vm.$refs.DeliveryData.deliveryDate,
                              cityId: _vm.currentLocality.city_id,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("DeliveryData", {
                    ref: "DeliveryData",
                    attrs: { checkDeliveryDate: _vm.checkDeliveryDate },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("CommentBlock", { ref: "commentBlock" }),
            _vm._v(" "),
            (_vm.$editNewOrder.files ?? []).length
              ? _c("div", { staticClass: "card" }, [
                  _c(
                    "div",
                    { staticClass: "card-body" },
                    [
                      _c("UploadImages", {
                        attrs: {
                          "block-upload": true,
                          files: _vm.$editNewOrder.files,
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _vm.adminEditOrder
                    ? [
                        _c(
                          "div",
                          { staticClass: "flex" },
                          [
                            _c("div", { staticClass: "form-group" }, [
                              _vm._v(
                                "\n              Статус заявки\n              "
                              ),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.$editNewOrder.status,
                                      expression: "$editNewOrder.status",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          _vm.$editNewOrder,
                                          "status",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      _vm.statusUpdated,
                                    ],
                                  },
                                },
                                _vm._l(
                                  _vm.$statusTitles,
                                  function (status, id) {
                                    return _c(
                                      "option",
                                      { domProps: { value: id } },
                                      [_vm._v(_vm._s(status))]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                            _vm._v(" "),
                            [-2, -3].includes(+_vm.$editNewOrder.status)
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "form-group ml-1" },
                                    [
                                      _vm._v(
                                        "\n                Причина отказа\n                "
                                      ),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.$editNewOrder.reject_comment,
                                            expression:
                                              "$editNewOrder.reject_comment",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        domProps: {
                                          value:
                                            _vm.$editNewOrder.reject_comment,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.$editNewOrder,
                                              "reject_comment",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            [2, -3, 3].includes(+_vm.$editNewOrder.status)
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "form-group ml-1" },
                                    [
                                      _vm._v(
                                        "\n                Курьер\n                "
                                      ),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.$editNewOrder.runner_id,
                                              expression:
                                                "$editNewOrder.runner_id",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.$set(
                                                _vm.$editNewOrder,
                                                "runner_id",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                          },
                                        },
                                        _vm._l(
                                          _vm.getRunnerByOrder(),
                                          function (runner, i) {
                                            return _c(
                                              "option",
                                              {
                                                domProps: { value: runner.id },
                                              },
                                              [_vm._v(_vm._s(runner.name))]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            [-2, -3, 3].includes(+_vm.$editNewOrder.status)
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "form-group ml-1" },
                                    [
                                      _vm._v(
                                        "\n                Дата отчета\n                "
                                      ),
                                      _c("OrderDateSelect", {
                                        ref: "selectedReportDate",
                                        attrs: {
                                          disabledBefore:
                                            _vm.reportDateDisabledBefore,
                                          disabled: true,
                                          onSelect: (date) =>
                                            _vm.updateOrderReportDate(date),
                                          selectedDate:
                                            _vm.$editNewOrder.report_date,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("LoadingButton", {
                          attrs: {
                            title: "Сохранить заявку",
                            className: "btn btn-success",
                            color: "white",
                            loading: _vm.loadingBtn,
                            onClick: () => _vm.updateOrder(),
                          },
                        }),
                      ]
                    : [
                        _vm.allowToEditOrder
                          ? _c(
                              "div",
                              { staticClass: "flex justify-content-between" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "min-w-300" },
                                  [
                                    !_vm.refund
                                      ? [
                                          !_vm.showRejectBlock
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-outline-warning",
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.showRejectBlock =
                                                        !_vm.showRejectBlock
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "Отказ\n                "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.showRejectBlock
                                            ? _c(
                                                "div",
                                                [
                                                  _c("RejectTypeSelect"),
                                                  _vm._v(" "),
                                                  _c("LoadingButton", {
                                                    attrs: {
                                                      title:
                                                        "Подтвердить отказ",
                                                      className:
                                                        "btn btn-outline-warning",
                                                      color:
                                                        _vm.$constants
                                                          .WARNING_COLOR,
                                                      loading: _vm.loadingBtn,
                                                      onClick: () =>
                                                        _vm.updateOrder(
                                                          false,
                                                          true
                                                        ),
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex flex_gap_10" },
                                  [
                                    _c("LoadingButton", {
                                      attrs: {
                                        title: "Отметить заявку как спрос",
                                        className: "btn btn-outline-info",
                                        loading: _vm.loadingBtn,
                                        color: _vm.$constants.LOADING_COLOR,
                                        onClick: () => _vm.updateOrderCustom(),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.allowToPassDelivery
                                      ? [
                                          _c("LoadingButton", {
                                            attrs: {
                                              title: "передать заявку на ФДК",
                                              className: "btn btn-info",
                                              color:
                                                _vm.$constants.LOADING_COLOR,
                                              loading: _vm.loadingBtn,
                                              onClick: () =>
                                                _vm.updateOrder(
                                                  false,
                                                  false,
                                                  true
                                                ),
                                            },
                                          }),
                                        ]
                                      : [
                                          _c("LoadingButton", {
                                            attrs: {
                                              title: "Отправить заявку",
                                              className: "btn btn-info",
                                              color: "white",
                                              loading: _vm.loadingBtn,
                                              onClick: () =>
                                                _vm.updateOrder(true),
                                            },
                                          }),
                                        ],
                                    _vm._v(" "),
                                    _c("LoadingButton", {
                                      attrs: {
                                        title: "Сохранить заявку",
                                        className: "btn btn-success",
                                        color: "white",
                                        loading: _vm.loadingBtn,
                                        onClick: () => _vm.updateOrder(),
                                      },
                                    }),
                                  ],
                                  2
                                ),
                              ]
                            )
                          : _c("div", { staticClass: "alert alert-warning" }, [
                              _c("p", [
                                _vm._v(
                                  "Доступ к редактированию заявки - запрещен"
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.$editNewOrder.status < 0
                                ? _c("p", [
                                    _vm._v(
                                      "Причина отказа: " +
                                        _vm._s(_vm.$editNewOrder.reject_comment)
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                      ],
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _vm._m(5),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c("orderTrace", {
                    attrs: { trace: this.$editNewOrder.trace },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Клиент")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header bg-warning" }, [
      _c("h6", [
        _c("i", { staticClass: "icon-fa icon-fa-warning" }),
        _vm._v(" В заявке были указаны другие препараты"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Кол")]),
        _vm._v(" "),
        _c("th", [_vm._v("Цена")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Препараты")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Доставка")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("История")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }